import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { CrashScreen } from './CrashScreen';

/**
 * React Router v7 error element. Fires for 404s, loader / action throws, and
 * uncaught render errors inside a route. The whole-app boundary still wraps
 * this, but RouteError gives finer-grained handling per route.
 */
export const RouteError = (): React.JSX.Element => {
  const { t } = useTranslation();
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const status = isRouteErrorResponse(error) ? error.status : 500;

  if (is404) {
    return (
      <CrashScreen
        title={t('errors.notFound.title')}
        description={t('errors.notFound.message')}
        statusCode={404}
        primaryLabel={t('errors.notFound.cta')}
        onPrimary={() => window.location.assign('/')}
      />
    );
  }

  return (
    <CrashScreen
      title={t('errors.crash.title')}
      description={t('errors.crash.message')}
      statusCode={status}
      error={error}
      primaryLabel={t('errors.crash.cta')}
      onPrimary={() => window.location.reload()}
      secondaryLabel="Go to dashboard"
      onSecondary={() => window.location.assign('/')}
    />
  );
};
